/* Manual invoice request through Shopify contact delivery; never creates or pays an order. */
(()=>{
  const dialog=document.getElementById('bw-ach-request-preview');
  if(!dialog||typeof dialog.showModal!=='function')return;
  let opener=null;
  let suppressEscapeRelease=false;
  const money=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'});
  const request=dialog.querySelector('[data-bw-ach-request-step]');
  const confirmation=dialog.querySelector('[data-bw-ach-confirm-step]');
  function reset(){request.hidden=false;confirmation.hidden=true;}
  function close(){dialog.close();}
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-bw-ach-open]');
    if(!button)return;
    event.preventDefault();
    const subtotal=Number(button.dataset.bwAchMerchandise);
    const savings=Number(button.dataset.bwAchSavings);
    if(!Number.isSafeInteger(subtotal)||subtotal<100000||!Number.isSafeInteger(savings)||savings<0)return;
    opener=button;
    reset();
    dialog.querySelector('[data-bw-ach-subtotal]').textContent=money.format(subtotal/100);
    dialog.querySelector('[data-bw-ach-discount]').textContent='−'+money.format(savings/100);
    dialog.querySelector('[data-bw-ach-after]').textContent=money.format((subtotal-savings)/100)+' USD';
    dialog.querySelector('[data-bw-ach-email]').value='';
    dialog.showModal();
  });
  dialog.querySelector('[data-bw-ach-close]').addEventListener('click',close);
  dialog.addEventListener('click',event=>{
    event.stopPropagation();
    if(event.target!==dialog)return;
    const box=dialog.getBoundingClientRect();
    if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)close();
  });
  dialog.addEventListener('keydown',event=>{if(dialog.open)event.stopPropagation();});
  document.addEventListener('keydown',event=>{
    if(dialog.open&&event.key==='Escape'){
      suppressEscapeRelease=true;
      event.stopImmediatePropagation();
    }
  },true);
  document.addEventListener('keyup',event=>{
    if(suppressEscapeRelease&&event.key==='Escape'){
      suppressEscapeRelease=false;
      event.stopImmediatePropagation();
    }
  },true);
  dialog.addEventListener('close',()=>{
    reset();
    requestAnimationFrame(()=>{
      const target=opener?.isConnected?opener:document.querySelector('#mini-cart[aria-hidden="false"] [data-bw-ach-open],.cart-recap [data-bw-ach-open]');
      target?.focus();
    });
  });
  const form=dialog.querySelector('#bw-ach-invoice-form');
  const send=dialog.querySelector('[data-bw-ach-send]');
  const error=dialog.querySelector('[data-bw-ach-error]');
  const result=dialog.querySelector('[data-bw-ach-form-result]');
  let prepared=false,busy=false;
  const pendingKey='bw-ach-request-pending';
  if(sessionStorage.getItem(pendingKey)&&(result.dataset.posted==='true'||result.dataset.errors==='true')){
    sessionStorage.removeItem(pendingKey);dialog.showModal();
    if(result.dataset.posted==='true'){request.hidden=true;confirmation.hidden=false;dialog.querySelector('[data-bw-ach-back]').focus();}
  }
  form.addEventListener('submit',async event=>{
    if(prepared){send.disabled=true;return;}
    event.preventDefault();if(busy||!form.reportValidity())return;
    busy=true;send.disabled=true;send.textContent='Preparing request…';error.hidden=true;
    try{
      const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('Unable to read your cart. Please try again.');
      const cart=await response.json();
      if(cart.currency!=='USD'||window.Shopify?.country!=='US')throw new Error('This option is for U.S. orders in USD. Please review your country selection.');
      const eligible=cart.items.filter(item=>!item.gift_card&&Number(item.product_id)!==15405932347560);
      const merchandise=eligible.reduce((sum,item)=>sum+item.final_line_price,0);
      if(merchandise<100000)throw new Error('Your eligible merchandise must total at least $1,000 USD. Please review your cart.');
      const savings=Math.round(merchandise*0.02);
      const identifier=crypto.randomUUID();
      const lines=cart.items.map((item,index)=>[
        (index+1)+'. '+item.product_title,
        'Variant: '+(item.variant_title||'Default')+' | SKU: '+(item.sku||'not supplied')+' | Variant ID: '+item.variant_id,
        'Quantity: '+item.quantity+' | Unit price: '+money.format(item.final_price/100)+' | Line total: '+money.format(item.final_line_price/100),
        'Product: '+new URL(item.url,location.origin).href,
        ...(item.discounts||[]).map(d=>'Discount: '+d.title+' '+money.format(d.amount/100)),
        ...Object.entries(item.properties||{}).filter(([key])=>!key.startsWith('_')).map(([key,value])=>key+': '+String(value)),
        Number(item.product_id)===15405932347560?'Delivery Guarantee: excluded from ACH savings.':item.gift_card?'Gift card purchase: excluded from ACH savings.':''
      ].filter(Boolean).join('\n'));
      const rebuild=new URL('/cart/'+cart.items.map(item=>item.variant_id+':'+item.quantity).join(','),location.origin);rebuild.searchParams.set('currency','USD');
      const body=['ACH INVOICE REQUEST — manual review required','Request ID: '+identifier,'Submitted: '+new Date().toISOString(),'Customer: '+form.elements['contact[name]'].value,'Reply email: '+form.elements['contact[email]'].value,'Market: US | Currency: USD','',...lines.flatMap(line=>[line,'']),'Eligible merchandise: '+money.format(merchandise/100),'Estimated ACH savings (2%): '+money.format(savings/100),'Eligible merchandise after savings: '+money.format((merchandise-savings)/100),'Current cart total: '+money.format(cart.total_price/100),'Cart discounts: '+money.format(cart.total_discount/100),'Shipping and tax: to be confirmed in invoice','Rebuild cart: '+rebuild.href,'Cart link rebuilds variant quantities; current prices and availability may change.','No order, inventory reservation, discount or payment has been created. Confirm availability, shipping, tax, promotion compatibility and invoice total manually.'].join('\n');
      dialog.querySelector('[data-bw-ach-cart-body]').value=body;
      sessionStorage.setItem(pendingKey,identifier);prepared=true;send.disabled=false;send.textContent='Send invoice request';form.requestSubmit(send);
    }catch(e){busy=false;prepared=false;send.disabled=false;send.textContent='Send invoice request';error.textContent=e.message||'Unable to prepare your request. Please try again.';error.hidden=false;}
  });
  dialog.querySelector('[data-bw-ach-back]').addEventListener('click',close);
})();
